// extracted by mini-css-extract-plugin
module.exports = {"side_panel":"SidePanel_side_panel__2Okv_","side_panel__tab":"SidePanel_side_panel__tab__1j681","side_panel__tab__selected":"SidePanel_side_panel__tab__selected__2SoGU"};